const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL;

/**
 * Build a full S3 URL from an S3 key (fileUrl).
 * The backend returns just the S3 key — prepend the base URL.
 */
export const getFullMediaUrl = (fileUrl: string | null | undefined): string => {
  if (!fileUrl) return "";
  // If already a full URL, return as-is
  if (fileUrl.startsWith("http://") || fileUrl.startsWith("https://")) {
    return fileUrl;
  }
  return `${S3_BASE_URL}/${fileUrl}`;
};
